import React from 'react';
import _ from 'lodash';
import { Map } from 'katri-map';
import { ActiveUser } from '../../utils/authentication/types';

interface MapWrapperProps {
  userData?: ActiveUser;
}

// @ts-ignore
const MapWrapper = ({ userData }: MapWrapperProps) => <Map userData={userData}/>;

const areEqual = (prevProps: MapWrapperProps, nextProps: MapWrapperProps) => {
  const prevUserWithoutLayers = {
    firstName: prevProps.userData?.firstName,
    lastName: prevProps.userData?.lastName,
    identificationCode: prevProps.userData?.identificationCode,
    roles: prevProps.userData?.roles,
  };

  const nextUserWithoutLayers = {
    firstName: nextProps.userData?.firstName,
    lastName: nextProps.userData?.lastName,
    identificationCode: nextProps.userData?.identificationCode,
    roles: nextProps.userData?.roles,
  };

  return _.isEqual(prevUserWithoutLayers, nextUserWithoutLayers);
};

export default React.memo(MapWrapper, areEqual);
